import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col align-self-center" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col align-self-center" }, null, -1)
const _hoisted_3 = { class: "advent-calender__container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fs-h4 fw-bold text-center" }, " DIE 2ZENS WÜNSCHEN EINE BESINNLICHE WEIHNACHTSZEIT! ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-normal text-center" }, " Jeden Tag gibt es tolle Angebote. Einfach Türchen öffnen und Kontaktdaten da lassen! ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1)
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { id: "advent-calender" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<footer><div class=\"row\"><div class=\"col-3 text-left\"><strong>2Zens Bike GmbH &amp; Co. KG</strong><br> Im Heetwinkel 42<br> 46514 Schermbeck </div><div class=\"col-7\"> 02853 / 44 88 48<br> info@zens.bike </div><div class=\"col-auto\"><br><br><a href=\"https://www.zens.bike/datenschutz.php\" target=\"_blank\"> Datenschutz </a>  |  <a href=\"https://www.zens.bike/impressum.php\" target=\"_blank\"> Impressum </a></div></div></footer>", 1)

import BaseSpacer from '@/components/BaseSpacer.vue';
import AdventCalenderForm from '@/AdventCalenderForm.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdventCalender',
  setup(__props) {

const { ioappConfig } = window;

const calenderDay = ref(new Date().getDate());

const headerLogoSrc = `${ioappConfig.themeUri}/assets/img/zens_bike_logo_weiss.png`;

const adventGifts = [
  {
    day: 1,
    headline: 'TAG 1',
    price: 'Electra Vale Go! <s>3099,00 €</s> ➝ <b>2499,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/1.jpg`,
  },
  {
    day: 2,
    headline: 'TAG 2',
    price: 'Lezyne Minipumpe CNC Drive HV (verschiedene Farben) <s>26,95 €</s> ➝ <b>15,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/2.jpg`,
  },
  {
    day: 3,
    headline: 'TAG 3',
    price: 'R Raymon HardRay Nine 8.0 43 cm <s>2399,00 €</s> ➝ <b>1999,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/3.jpg`,
  },
  {
    day: 4,
    headline: 'TAG 4',
    price: 'Bontrager Rapid Pack Hydro inkl. Handschuhe, Schlauch, Mütze, 2Zens Trinkflasche, Reifenheber, Schloss, Multifunktionswerkzeug & Tublesskit <s>224,00 €</s> ➝ <b>150,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/4.jpg`,
  },
  {
    day: 5,
    headline: 'TAG 5',
    price: 'TREK E-Caliber 9.6 XL <s>6799,00 €</s> ➝ <b>5250,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/5.jpg`,
  },
  {
    day: 6,
    headline: 'TAG 6',
    price: 'GONSO Cancano/Bernira 2-in-1 Windjacke (ver. Farben/Größen) <s>129,95 €</s> ➝ <b>90,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/6.jpg`,
  },
  {
    day: 7,
    headline: 'TAG 7',
    price: 'Mondraker Podium Carbon R L <s>5699,00 €</s> ➝ <b>4999,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/7.jpg`,
  },
  {
    day: 8,
    headline: 'TAG 8',
    price: 'FIZIK MTB-Winterschuhe Artica X5 (vers. Größen) <s>200,00 €</s> ➝ <b>100,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/8.jpg`,
  },
  {
    day: 9,
    headline: 'TAG 9',
    price: 'Mondraker Factor 26 <s>1999,00 €</s> ➝ <b>1699,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/9.jpg`,
  },
  {
    day: 10,
    headline: 'TAG 10',
    price: 'Leyzne LED Fahrradbeleuchtung Power High Beam 500 Loaded STVZO Vorderlicht <s>149,95 €</s> ➝ <b>119,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/10.jpg`,
  },
  {
    day: 11,
    headline: 'TAG 11',
    price: 'SI BMX ST 1 <s>369,99 €</s> ➝ <b>299,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/11.jpg`,
  },
  {
    day: 12,
    headline: 'TAG 12',
    price: 'Bontrager Schloss <s>39,99 €</s> ➝ <b>23,99 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/12.jpg`,
  },
  {
    day: 13,
    headline: 'TAG 13',
    price: 'BH Xtep Lynx Carbon Pro 5.5 M <s>7799,00 €</s> ➝ <b>6599,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/13.jpg`,
  },
  {
    day: 14,
    headline: 'TAG 14',
    price: 'BH Atom City Wave M <s>2299,90 €</s> ➝ <b>1500,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/14.jpg`,
  },
  {
    day: 15,
    headline: 'TAG 15',
    price: 'Mondraker Foxy R M/XL <s>4399,00 €</s> ➝ <b>3950,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/15.jpg`,
  },
  {
    day: 16,
    headline: 'TAG 16',
    price: 'Maloja Mützen (ver. Farben) für <b>je 5,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/16.jpg`,
  },
  {
    day: 17,
    headline: 'TAG 17',
    price: 'BH Expert 4,5 (vers. Größen) <s>1199,90 €</s> ➝ <b>950,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/17.jpg`,
  },
  {
    day: 18,
    headline: 'TAG 18',
    price: 'Reinigungspaket: Muc Off Bike Cleaner + Muc Off Wet Lube + Voxom Fahrrad Zahnkranzreinigungsbürste für <b>29 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/18.jpg`,
  },
  {
    day: 19,
    headline: 'TAG 19',
    price: 'BBF Miami Bafang <s>4649,00 €</s> ➝ <b>3999,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/19.jpg`,
  },
  {
    day: 20,
    headline: 'TAG 20',
    price: 'Mondraker Podium Carbon M <s>3799,00 €</s> ➝ <b>2999,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/20.jpg`,
  },
  {
    day: 21,
    headline: 'TAG 21',
    price: 'BH Ultimate RC 7.5 L <s>2249,90 €</s> ➝ <b>1950,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/21.jpg`,
  },
  {
    day: 22,
    headline: 'TAG 22',
    price: 'Felt Broam 40 58cm <s>1799,00</s> € ➝ <b>1499,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/22.jpg`,
  },
  {
    day: 23,
    headline: 'TAG 23',
    price: 'Helme: <b>10 %</b> Rabatt auf das ganze Sortiment',
    img: `${ioappConfig.themeUri}/assets/img/items/23.jpg`,
  },
  {
    day: 24,
    headline: 'TAG 24',
    price: 'Conway MWE 827 50cm Sonderaufbau <s>6399,00 €</s> ➝ <b>3800,00 €</b>',
    img: `${ioappConfig.themeUri}/assets/img/items/24.jpg`,
  },
];

const selectedDay = ref<null | Record<string, number | string>>();

const openAdventForm = (adventDay: number) => {
  const currentDate = new Date();
  const currentDay = currentDate.getDate();

  if (currentDay >= adventDay) {
    selectedDay.value = adventGifts[adventDay - 1];
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("div", { class: "row no-gutters" }, [
          _hoisted_1,
          _createElementVNode("div", { class: "col-auto" }, [
            _createElementVNode("a", { href: "https://zens.bike" }, [
              _createElementVNode("img", {
                class: "align-center",
                src: headerLogoSrc
              })
            ])
          ]),
          _hoisted_2
        ])
      ])
    ]),
    (selectedDay.value)
      ? (_openBlock(), _createBlock(AdventCalenderForm, {
          key: 0,
          day: calenderDay.value,
          "selected-day": selectedDay.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (selectedDay.value = null))
        }, null, 8, ["day", "selected-day"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseSpacer, { size: "l" }),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseSpacer),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([8, 23, 2, 12, 18, 21, 11, 19, 6, 15, 3, 10, 1, 24, 7, 16, 22, 13, 20, 14, 4, 9, 17, 5], (day) => {
              return _createElementVNode("div", {
                key: `advent-day-${day}`,
                class: _normalizeClass(`day-${day}`),
                onClick: ($event: any) => (openAdventForm(day))
              }, [
                _createElementVNode("div", null, _toDisplayString(day), 1)
              ], 10, _hoisted_10)
            }), 64))
          ])
        ])
      ])
    ]),
    _hoisted_11
  ], 64))
}
}

})